<template>
  <div class="model-viewer-wrapper">
    <!-- Use the actual model-viewer if it was successfully loaded -->
    <component 
      v-if="modelViewerLoaded"
      :is="modelViewerComponent"
      ref="modelViewer"
      :src="src"
      :alt="alt"
      :camera-controls="cameraControls"
      :auto-rotate="autoRotate"
      :style="wrapperStyle"
      @load="onModelLoad"
      @error="onModelError"
      @click="$emit('click', $event)"
    ></component>

    <!-- Use the fallback component if model-viewer fails to load -->
    <fallback-model-viewer
      v-else
      :src="src"
      :alt="alt"
      :fallback-image-url="fallbackImageUrl"
      :style="wrapperStyle"
      @load="onFallbackLoad"
      @click="$emit('click', $event)"
    ></fallback-model-viewer>
  </div>
</template>

<script>
import FallbackModelViewer from './FallbackModelViewer.vue';

export default {
  name: 'ModelViewerWrapper',
  components: {
    FallbackModelViewer
  },
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: '3D Model'
    },
    cameraControls: {
      type: Boolean,
      default: true
    },
    autoRotate: {
      type: Boolean,
      default: true
    },
    fallbackImageUrl: {
      type: String,
      default: 'https://pub-083487639dd44281913f58e8e6638018.r2.dev/human_diagram.png'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      modelViewerLoaded: false,
      modelViewerComponent: null,
      loading: true,
      error: false
    };
  },
  computed: {
    wrapperStyle() {
      return {
        width: this.width,
        height: this.height
      };
    }
  },
  created() {
    this.loadModelViewer();
  },
  methods: {
    async loadModelViewer() {
      try {
        // Try to dynamically import the model-viewer component
        const modelViewerModule = await import('@google/model-viewer');
        
        // If model-viewer is successfully loaded
        console.log('Model-viewer loaded successfully:', modelViewerModule);
        
        // Check if we're in a browser environment
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
          // Create the model-viewer element via component registration
          this.modelViewerComponent = 'model-viewer';
          this.modelViewerLoaded = true;
        } else {
          // Fall back to the fallback component for SSR or tests
          this.modelViewerLoaded = false;
          console.warn('Model-viewer running in non-browser environment, using fallback');
        }
      } catch (error) {
        console.error('Error loading model-viewer, using fallback:', error);
        this.modelViewerLoaded = false;
      }
    },
    onModelLoad() {
      this.loading = false;
      this.error = false;
      this.$emit('load');
    },
    onModelError(error) {
      this.loading = false;
      this.error = true;
      console.error('Error loading 3D model:', error);
      this.$emit('error', error);
    },
    onFallbackLoad() {
      this.loading = false;
      this.$emit('load');
    }
  }
};
</script>

<style scoped>
.model-viewer-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>